import { set, map } from 'lodash/fp';

export const paginationSuccessHandler = (
  paginationState,
  { items, meta },
  mapBy = 'id'
) => ({
  currentPage: meta.page,
  totalPages: meta.pages,
  totalCount: meta.total,
  limit: meta.limit,
  pages: set(
    `${meta.page}`,
    {
      ids: map(mapBy, items),
      fetching: false
    },
    paginationState.pages
  )
});
